import { useEffect } from 'react';
import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { Iconify } from '../../iconify';
import { useSupportDrawerContext } from '../context/use-support-drawer-context';

import type { SupportDrawerProps } from '../types';

// ----------------------------------------------------------------------

export function SupportDrawer({ width }: SupportDrawerProps) {
  const drawerContext = useSupportDrawerContext();

  useEffect(() => {
    if (width && width != drawerContext.drawerWidth) drawerContext.setWidth(width);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderHead = () => (
    <Box
      sx={{
        py: 2,
        pr: 1,
        pl: 2.5,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Support Ticket #{drawerContext.supportTicketId}
      </Typography>

      <Tooltip title="Close">
        <IconButton onClick={drawerContext.onCloseDrawer}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={drawerContext.openDrawer}
      onClose={drawerContext.onCloseDrawer}
      slotProps={{
        backdrop: { invisible: true },
        paper: {
          sx: [
            (theme) => ({
              ...theme.mixins.paperStyles(theme, {
                color: varAlpha(theme.vars.palette.background.defaultChannel, 0.9),
              }),
              width: drawerContext.drawerWidth,
              boxShadow: 5,
            }),
          ],
        },
      }}
    >
      {renderHead()}
    </Drawer>
  );
}
